import i18n from "i18next";

const defaultLangs = ["en", "de"];

export const loadTranslations = async (
  ns: string,
  langs: string[] = defaultLangs,
) => {
  try {
    await i18n.reloadResources(langs, ns);
  } catch (error) {
    /* eslint-disable no-console */
    console.error(error);
  }

  return "";
};
